import { render, staticRenderFns } from "./26October.vue?vue&type=template&id=20959876"
import script from "./26October.vue?vue&type=script&lang=js"
export * from "./26October.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports